import React from 'react';
import Reflux from 'reflux';
import AppStore from '../../AppStore';
import './AutocompleteInput.css';
import AppActions from '../../AppActions';
import RcIf, {RcElse} from 'rc-if';
class AutocompleteOptionInput extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            option: props.option || {sentence: ''},
            optionIndex: props.optionIndex,
            topic: props.topic,
            autocompleteResponse: [],
            enableEditing: props.enableEditing,
            heightTextarea: 'auto'
        };
        this.search = this.search.bind(this);
        this.handleChangeOption = this.handleChangeOption.bind(this);
        this.focusOptionIndex = this.focusOptionIndex.bind(this);
        this.store = AppStore;
    }
    componentWillReceiveProps (newProps) {
        this.setState({
            option: newProps.option || {sentence: ''},
            optionIndex: newProps.hasOwnProperty('optionIndex')
              ? newProps.optionIndex : this.state.optionIndex,
            topic: newProps.topic,
            autocompleteResponse: [],
            enableEditing: newProps.enableEditing
        });
    }
    search (query) {
        AppActions.searchOption(query);
        this.setState({responseEnabled: true});
    }
    focusOptionIndex (index) {
        if (!this.state.enableEditing) {
            return;
        }
        AppActions.focusOptionIndex(index);
    }
    enableAllResponses () {
        this.setState({allResponsesVisible: true});
    }
    handleChangeOption (e) {
        if (this.state.enableEditing) {
            let value = e.target.value;
            let option = this.state.option;
            option.sentence = value;
            if (value.length > 2) {
                this.search(value);
            } else {
                this.setState({
                    autocompleteResponse: []
                });
            }
            this.setState({
                option: option,
                heightTextarea: e.target.scrollHeight + 'px'
            });
        }
    }

    render () {
        return (
          <div>
            <RcIf if={this.state.enableEditing}>
              <textarea maxLength='143' rows='1' tabIndex={(this.state.optionIndex + 1)} className='cardsTop' style={{height: this.state.heightTextarea}} onFocus={() => { this.focusOptionIndex(this.state.optionIndex); }} name={this.props.optionIndex} onChange={this.handleChangeOption} value={this.state.option.sentence} autoFocus={this.state.optionIndex === 0} />
              <RcElse>
                <p className='cardsTop option_lines'>{this.state.option.sentence}</p>
              </RcElse>
            </RcIf>
          </div>
        );
    }
}

export default AutocompleteOptionInput;



// WEBPACK FOOTER //
// ./src/components/topic/AutocompleteInput.js